import spanish from './spanish';

export default spanish;
